import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { filteredByType } from '../features/filters/filterSlice';

function Sidebar() {
    //Variables
    const dispatch = useDispatch();
    const navigate= useNavigate();
    //Functions
    const handleTypeChange = (typeStatus) => {
        dispatch(filteredByType(typeStatus));
        navigate("/jobs");
    }

    return (
        <div className="sidebar">
            <nav>
                <ul className="space-y-4">
                    <li>
                        <Link to="/jobs" className="main-menu menu-active" id="lws-alljobs-menu">
                            <i className="fa-solid fa-briefcase"></i>
                            <span onClick={() => handleTypeChange("all")}> All Available Jobs</span>
                        </Link>
                        <ul className="space-y-6 lg:space-y-2 ">
                            <li>
                                <a href="#" className="sub-menu" id="lws-internship-menu" onClick={() => handleTypeChange("Internship")}>
                                    <i className="fa-solid fa-stop !text-[#FF5757]"></i>
                                    Internship
                                </a>
                            </li>
                            <li>
                                <a href="#" className="sub-menu" id="lws-fulltime-menu" onClick={() => handleTypeChange("Full Time")}>
                                    <i className="fa-solid fa-stop !text-[#FF8A00]"></i>
                                    Full Time
                                </a>
                            </li>
                            <li>
                                <a href="#" className="sub-menu" id="lws-remote-menu" onClick={() => handleTypeChange("Remote")}>
                                    <i className="fa-solid fa-stop !text-[#56E5C4]"></i>
                                    Remote
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/jobs/new" className="main-menu" id="lws-addJob-menu">
                            <i className="fa-solid fa-file-circle-plus"></i>
                            <span>Add NewJob</span>
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Sidebar